<div class="layout-wrapper layout-theme-light layout-static bg-surface-50">
    <app-topbar />
    <div class="layout-sidebar">
      <app-sidebar />
    </div>
    <div class="layout-main-container">
      <div class="layout-main platform-layout-main">
        <router-outlet></router-outlet>
      </div>
    </div>
    <div class="layout-mask"></div>
  </div>